export default "__VITE_ASSET__CZO0122Z__"